import { fromJS } from 'immutable';
import { fetchItemTypesRoutine } from '../routines';

const initialState = fromJS({
  itemTypes: {},
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchItemTypesRoutine.SUCCESS:
      return state.set('itemTypes', fromJS(action.payload.response));
    case fetchItemTypesRoutine.FAILURE:
      return state.setIn(['itemTypes', 'loading'], false);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/itemtypes.js